import { useState } from "react";
import {
  genElDate,
  genElNumber,
  genElObject,
  genElText,
} from "@components/utils/EditorDialogElementGenerator";
import DepartmentSelectorDialog from "../../../../dialogs/selectors/DepartmentSelectorDialog";
import JenisMinyakSelectorDialog from "../../../../dialogs/selectors/JenisMinyakSelectorDialog";
import FieldTextarea from "./field-textarea";
import SectionCard from "./section-card";
import SignatureRow from "./signature-row";

const signers = [
  { name: "diajukan_oleh", label: "Diajukan", title: "Pemohon Unit" },
];

// I. Pengajuan (Unit)
const SectionPengajuan = (props) => {
  const { data, setData, error, stage, saving, onSave, signProps, cardProps } = props;

  const [showDepartmentSelector, setShowDepartmentSelector] = useState(false);
  const [showJenisMinyakSelector, setShowJenisMinyakSelector] = useState(false);

  const disabled = stage !== "active";

  const handleOnConfirmDepartment = (event, datas) => {
    if (datas && datas.length > 0) {
      const department = datas[0];
      setData((prevData) => ({
        ...prevData,
        data_department: department,
        department_id: department.id,
      }));
      setShowDepartmentSelector(false);
    }
  };

  const handleOnConfirmJenisMinyak = (event, datas) => {
    if (datas && datas.length > 0) {
      const jenisMinyak = datas[0];
      setData((prevData) => ({
        ...prevData,
        data_jenis_minyak: jenisMinyak,
        jenis_minyak_id: jenisMinyak.id,
      }));
      setShowJenisMinyakSelector(false);
    }
  };

  return (
    <SectionCard
      {...cardProps}
      code="I"
      title="Pengajuan"
      role="Unit"
      stage={stage}
      saving={saving}
      onSave={onSave}
      signatures={
        <SignatureRow
          signers={signers}
          data={data}
          canSign={stage === "active"}
          {...signProps}
        />
      }
    >
      <DepartmentSelectorDialog
        title={"Pilih Department"}
        visible={showDepartmentSelector}
        onHide={() => setShowDepartmentSelector(false)}
        onConfirm={handleOnConfirmDepartment}
      />

      <JenisMinyakSelectorDialog
        title={"Pilih Jenis Minyak"}
        visible={showJenisMinyakSelector}
        onHide={() => setShowJenisMinyakSelector(false)}
        onConfirm={handleOnConfirmJenisMinyak}
      />

      {genElText({
        field: "nomor",
        name: "Nomor Dokumen",
        data: { nomor: data.nomor || "(dibuat otomatis saat disimpan)" },
        setData: () => {},
        disabled: true,
        error,
      })}
      {genElDate({
        field: "tanggal",
        name: "Tanggal",
        data,
        setData,
        error,
        disabled,
        primeFormat: "dd MM yy",
      })}
      {genElObject({
        field: "department_id",
        name: "Department (Unit Peminta)",
        value: data.data_department ? data.data_department.nama : "",
        error,
        disabled,
        onClick: () => setShowDepartmentSelector(true),
      })}
      {genElObject({
        field: "jenis_minyak_id",
        name: "Jenis Minyak",
        value: data.data_jenis_minyak ? data.data_jenis_minyak.nama : "",
        error,
        disabled,
        onClick: () => setShowJenisMinyakSelector(true),
      })}
      {genElNumber({
        field: "jumlah_diminta",
        name: "Jumlah Diminta (Liter)",
        data,
        setData,
        error,
        disabled,
        showButtons: false,
        max_fraction_digits: 2,
      })}
      <FieldTextarea
        field="penggunaan"
        name="Penggunaan"
        data={data}
        setData={setData}
        error={error}
        disabled={disabled}
      />
    </SectionCard>
  );
};

export default SectionPengajuan;
